import { graphql, useStaticQuery } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';

import * as styles from './JobPostings.module.css';
import SmartLink from './SmartLink';

const Wrapper = ({ children, categoryId, name }) => {
  return (
    <div className={styles.category}>
      <hr className={styles.hr} />
      <h4 id={categoryId}>{name}</h4>
      <div className={styles.catList}>{children}</div>
    </div>
  );
};

/**
 * Component that accepts gatsby fetched jobs for immediate display, but
 * fetches from the api for any updates.
 */
class DynamicJobs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: '',
    };

    this.onSelect = this.onSelect.bind(this);
  }

  static propTypes = {
    /** Optional category to filter by */
    limitCategory: PropTypes.string,
  };

  onSelect(e) {
    this.setState({ filter: e.target.value });
  }

  render() {
    let ashbyJobs = [];
    if (this.props.ashbyJobs) {
      this.props.ashbyJobs
        .filter((j) => {
          if (this.state.filter) {
            return j.name === this.state.filter;
          }
          return true;
        })
        .forEach((dept, i) => {
          ashbyJobs.push(
            <Wrapper name={dept.name} key={i} categoryId={dept.name}>
              {dept.jobs.map((j, i) => {
                const titleId = j.title.replace(/[^0-9a-z]/gi, '');
                return (
                  <div className={styles.job} key={i} id={titleId}>
                    <h5>{j.team}</h5>
                    <h6>
                      <SmartLink to={`/careers/jobs/${j.alternative_id}`}>{j.title}</SmartLink>
                    </h6>
                    <span className={styles.location}>{j.location}</span>
                  </div>
                );
              })}
            </Wrapper>
          );
        });
    }

    return (
      <>
        <div className={styles.heading} id="job-posts">
          <h3>{this.props.heading}</h3>
          {ashbyJobs?.length > 0 && (
            <div>
              <label htmlFor="job-filter">Filter:</label>
              <select id="job-filter" value={this.state.filter} onChange={this.onSelect}>
                <option value="">All</option>
                {process.env.GATSBY_USE_ASHBY &&
                  this.props.ashbyJobs?.map((dept, i) => {
                    return (
                      <option value={dept.name} key={i}>
                        {dept.name}
                      </option>
                    );
                  })}
              </select>
            </div>
          )}
        </div>
        {ashbyJobs?.length > 0 && <div>{ashbyJobs}</div>}
        {!ashbyJobs?.length && (
          <div>
            <h4>We do not currently have any open roles</h4>
          </div>
        )}
      </>
    );
  }
}

/**
 * Displays the job board
 *
 * @param props
 * @returns {*}
 * @constructor
 */
const JobPostings = (props) => {
  const data = useStaticQuery(graphql`
    {
      allAshbyAshbyjobs(filter: { jobs: { elemMatch: { department: { ne: "dummy" } } } }) {
        nodes {
          jobs {
            alternative_id
            applyUrl
            address {
              addressRegion
              addressCountry
              addressLocality
            }
            department
            descriptionPlain
            descriptionHtml
            employmentType
            isListed
            isRemote
            jobUrl
            location
            publishedAt
            team
            title
          }
        }
      }
    }
  `);

  const ashbyDepts = [];
  data.allAshbyAshbyjobs?.nodes[0]?.jobs
    ?.filter((j) => j.location?.indexOf('Internal') === -1)
    ?.forEach((job) => {
      const deptIndex = ashbyDepts.findIndex((d) => d.name === job.department);
      if (deptIndex === -1) {
        ashbyDepts.push({ name: job.department, jobs: [job] });
      } else {
        ashbyDepts[deptIndex].jobs.push(job);
      }
    });
  return <DynamicJobs ashbyJobs={ashbyDepts} {...props} />;
};

export default JobPostings;
